const URL = '/cuentas';

const state = {
  all: [],
  selected: {
    id: null,
    documento: null,
    razon_social: null,
    numero: null,
    descripcion: null,
    tolerancia: null,
    cierre: null,
    saldo_usuario: 0,
    saldo_pleno: 0,
    saldo_subsidio: 0,
    kilos_pleno: 0,
    credito_demas: 0,
    cliente_id: null,
    recalculado_at: null,
    created_at: null,
    updated_at: null
  },
  edited: {
    id: null,
    documento: null,
    razon_social: null,
    numero: null,
    descripcion: null,
    tolerancia: null,
    cierre: null,
    saldo_usuario: 0,
    saldo_pleno: 0,
    saldo_subsidio: 0,
    kilos_pleno: 0,
    credito_demas: 0,
    cliente_id: null,
    recalculado_at: null,
    created_at: null,
    updated_at: null
  },
  filters: {
    searchText: null,
    numero: null,
    descripcion: null,
    cierre_from: null,
    cierre_to: null,
    cliente_id: null,
    cuenta_id: null,
    // cliente
    documento: null,
    razon_social: null,
    inactivo: null,
    cerradas: 0
  },
  loading: false,
  headers: [
    {
      text: 'Número',
      value: 'numero',
      align: 'center'
    },
    {
      text: 'Descripcion',
      value: 'descripcion',
      align: 'center'
    },
    {
      text: 'Fecha Cierre',
      value: 'cierre',
      align: 'center'
    },
  ],
  rules: {
    numero: [
      v => !!v || 'Este campo es necesario',
    ],
    descripcion: [
      // v => !!v || 'Este campo es necesario',
    ],
    cierre: [
      // v => !!v || 'Este campo es necesario',
    ],
    tolerancia: [
      // v => !!v || 'Este campo es necesario',
    ],
    cliente_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir un cliente asociado',
    ],
    sucursal_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir una sucursal asociada',
    ],
  },
  options: {
    itemsPerPage: 50,
    page: 1,
    sortBy: [],
    sortDesc: []
  },
  itemsLength: null,
}

// GETTERS
const getters = {
  all(state) {
    return state.all
  },
  cerrada(state) {
    return state.selected.cierre != null
  },
  edited(state) {
    return state.edited
  },
  selected(state) {
    return state.selected
  },
  selectedId(state) {
    return state.selected && state.selected.id > 0 ? state.selected.id : null
  },
  filters(state) {
    return state.filters
  },
  rules(state) {
    return state.rules
  },
  headers(state) {
    return state.headers
  },
  itemsLength(state) {
    return state.itemsLength
  },
  options(state) {
    return state.options
  },
  loading(state) {
    return state.loading
  },
  defaultable(state) {
    return state.edited.id === null &&
      state.edited.numero === null &&
      state.edited.descripcion === null &&
      state.edited.cierre === null &&
      state.edited.tolerancia === null
  },
  updatable(state) {
    return state.edited.id == state.selected.id && (
      state.edited.numero != state.selected.numero ||
      state.edited.descripcion != state.selected.descripcion ||
      state.edited.cierre != state.selected.cierre ||
      state.edited.tolerancia != state.selected.tolerancia
    )
  },
}

// ACTIONS
const actions = {
  onClearAll({ commit }) {
    commit('setAll', [])
    commit('setOptions', {
      itemsPerPage: 50,
      page: 1,
      sortBy: [],
      sortDesc: []
    })
  },
  onClearFilters({ commit }) {
    commit('setFilters', {
      searchText: null,
      numero: null,
      descripcion: null,
      cierre_from: null,
      cierre_to: null,
      cliente_id: null,
      cuenta_id: null,
      // cliente
      documento: null,
      razon_social: null,
      inactivo: null,
      cerradas: 0
    })
  },
  onClearEdited({ commit }) {
    commit('setEdited', {
      id: null,
      documento: null,
      razon_social: null,
      numero: null,
      descripcion: null,
      cierre: null,
      saldo_usuario: 0,
      saldo_pleno: 0,
      saldo_subsidio: 0,
      kilos_pleno: 0,
      credito_demas: 0,
      tolerancia: null,
      cliente_id: null,
      recalculado_at: null,
      created_at: null,
      updated_at: null,
    })
  },
  onClearSelected({ commit }) {
    commit('setSelected', {
      id: null,
      documento: null,
      razon_social: null,
      numero: null,
      descripcion: null,
      cierre: null,
      saldo_usuario: 0,
      saldo_pleno: 0,
      saldo_subsidio: 0,
      kilos_pleno: 0,
      credito_demas: 0,
      tolerancia: null,
      cliente_id: null,
      recalculado_at: null,
      created_at: null,
      updated_at: null,
    })
  },
  onFetch({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL, {
        params: {
          itemsPerPage: state.options.itemsPerPage,
          page: state.options.page,
          sortBy: state.options.sortBy[0],
          sortDesc: state.options.sortDesc[0] ? 1 : 0,
          searchText: state.filters.searchText,
          numero: state.filters.numero,
          documento: state.filters.documento,
          razon_social: state.filters.razon_social,
          inactivo: state.filters.inactivo,
          cliente_id: state.filters.cliente_id,
          cerradas: state.filters.cerradas
        }
      })
        .then(response => {
          commit('setAll', response.data.data)
          commit('setItemsLength', response.data.meta.total)
          if (state.options.page + state.options.itemsPerPage > response.data.meta.total)
            commit('setPage', 1)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onRefresh({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL + '/' + state.edited.id)
        .then(response => {
          const aux = {
            ...state.edited,
            documento: response.data.documento,
            razon_social: response.data.razon_social,
            numero: response.data.numero,
            descripcion: response.data.descripcion,
            tolerancia: response.data.tolerancia,
            cierre: response.data.cierre,
            kilos_pleno: response.data.kilos_pleno,
            saldo_pleno: response.data.saldo_pleno,
            saldo_subsidio: response.data.saldo_subsidio,
            saldo_usuario: response.data.saldo_usuario,
            credito_demas: response.data.credito_demas,
            cliente_id: response.data.cliente_id,
            recalculado_at: response.data.recalculado_at,
            created_at: response.data.created_at,
            updated_at: response.data.updated_at,
          }
          /** Se guarda la información en edited y selected del store Cuentas */
          commit('setEdited', aux)
          commit('setSelected', aux)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onSave({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.post(URL, state.edited)
        .then(response => {
          const aux = {
            ...state.edited,
            id: response.data.id,
          }
          commit('setEdited', aux)
          commit('setSelected', aux)
          commit('ResponseHTTP/addSuccess', 'La cuenta fue registrada', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error. No se registro la cuenta', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onUpdate({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.put(URL + '/' + state.edited.id, state.edited)
        .then(response => {
          const aux = {
            ...state.edited,
            documento: response.data.data.documento,
            razon_social: response.data.data.razon_social,
            numero: response.data.data.numero,
            descripcion: response.data.data.descripcion,
            tolerancia: response.data.data.tolerancia,
            cierre: response.data.data.cierre,
            cliente_id: response.data.data.cliente_id,
            recalculado_at: response.data.data.recalculado_at,
            created_at: response.data.data.created_at,
            updated_at: response.data.data.updated_at,
          }
          commit('setSelected', aux)
          commit('ResponseHTTP/addSuccess', 'La cuenta fue actualizada.', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error. No se actualizo la cuenta.', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onDelete({ state, commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.delete(URL + '/' + state.edited.id)
        .then(response => {
          commit('ResponseHTTP/addSuccess', 'La cuenta fue borrada.', { root: true })
          dispatch('onClearEdited')
          dispatch('onClearSelected')
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error. No se borro la cuenta.', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setAll(state, payload) {
    state.all = payload.slice()
  },
  setEdited(state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setSelected(state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setFilters(state, payload) {
    state.filters = Object.assign({}, payload)
  },
  setLoading(state, payload) {
    state.loading = payload
  },
  setPage(state, payload) {
    state.options.page = payload
  },
  setItemsPerPage(state, payload) {
    state.options.itemsPerPage = payload
  },
  setItemsLength(state, payload) {
    state.itemsLength = payload
  },
  setOptions(state, payload) {
    state.options = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
